import { render, staticRenderFns } from "./GenAI.vue?vue&type=template&id=1d87e366&"
import script from "./GenAI.vue?vue&type=script&lang=js&"
export * from "./GenAI.vue?vue&type=script&lang=js&"
import style0 from "./GenAI.vue?vue&type=style&index=0&id=1d87e366&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports